"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getMsGraphUrl = void 0;

var _url = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/url"));

var _overrideSettings = require("../shared/override-settings/overrideSettings");

var _getMsGraphResourceName = require("./getMsGraphResourceName");

var getMsGraphUrl = function getMsGraphUrl() {
  var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'v1.0';
  return function (path, queryString) {
    var location = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window.location;
    var overrideSetting = (0, _overrideSettings.getOverrideSetting)('msGraphResourceName');
    var url;

    if (overrideSetting) {
      url = new _url.default(version + path, overrideSetting);
    } else {
      url = new _url.default(version + path, (0, _getMsGraphResourceName.getMsGraphResourceName)(location));
    }

    url.search = queryString || '';
    return url;
  };
};

exports.getMsGraphUrl = getMsGraphUrl;